/* If you edit this file, please remove this header and clean up the resulting eslint errors.
 */
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  no-alert,
  no-console,
  react/jsx-no-target-blank,
  react/no-unescaped-entities,
  react/prop-types,
  no-restricted-syntax
*/
import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class EventLog extends React.Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      events: [],
      isCollapsed: false,
    };
    this.eventLogRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.client) {
      this.props.client.addEventListener(this.handleEvent);
    }
  }

  componentWillUnmount() {
    if (this.props.client) {
      this.props.client.removeEventListener(this.handleEvent);
    }
  }

  handleEvent = (eventData, fullLog) => {
    this.setState({ events: fullLog }, () => {
      // Auto-scroll to bottom
      if (this.eventLogRef.current) {
        this.eventLogRef.current.scrollTop =
          this.eventLogRef.current.scrollHeight;
      }
    });
  };

  clearLog = () => {
    if (this.props.client) {
      this.props.client.clearEventLog();
    }
    this.setState({ events: [] });
  };

  toggleCollapse = () => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  formatEventData(data) {
    if (!data) return 'null';
    return JSON.stringify(data, null, 2);
  }

  render() {
    const { events, isCollapsed } = this.state;

    return (
      <div className="event-log-container">
        <div className="event-log-header">
          <h3>Event Log ({events.length} events)</h3>
          <div className="event-legend">
            <span className="legend-item">
              <span className="legend-color legend-blue"></span>
              SDK Client Events
            </span>
            <span className="legend-item">
              <span className="legend-color legend-purple"></span>
              PostMessage Events
            </span>
          </div>
          <div className="event-controls">
            <button onClick={this.toggleCollapse} className="toggle-btn">
              {isCollapsed ? 'Show' : 'Hide'}
            </button>
            <button onClick={this.clearLog} className="clear-btn">
              Clear
            </button>
          </div>
        </div>

        {!isCollapsed && (
          <div className="event-log-content" ref={this.eventLogRef}>
            {events.length === 0 ? (
              <div className="no-events">
                No events captured yet. Launch an embedded flow to see events.
              </div>
            ) : (
              events.map((event, index) => (
                <div
                  key={index}
                  className="event-item"
                  data-testid={
                    event.type === 'postMessage'
                      ? 'postmessage-event'
                      : 'sdk-event'
                  }
                  data-event-type={event.type}
                  data-event-payload={
                    event.data ? JSON.stringify(event.data) : undefined
                  }
                >
                  <div className="event-header">
                    <span className="event-type">{event.type}</span>
                    {event.messageType && (
                      <span className="message-type">{event.messageType}</span>
                    )}
                    <span className="event-timestamp">
                      {new Date(event.timestamp).toLocaleTimeString()}
                    </span>
                  </div>
                  {event.data && (
                    <div className="event-data">
                      {this.formatEventData(event.data)}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    );
  }
}

export default EventLog;
